import React from 'react';
import { useTranslation } from 'react-i18next';
import { useContentBlock } from '../../hooks/useContentBlock';
import ContentBlockPlaceholder from '../content/ContentBlockPlaceholder';

/**
 * Editorial intro — "Manifiesto" section that appears after the hero.
 * Sourced from admin (page `home-editorial`, keys `home.manifest.header` and
 * `home.manifest.body`). Falls back to hardcoded defaults so the layout is
 * never empty, even before any admin has authored the blocks.
 */
const EditorialIntro = () => {
  const { t } = useTranslation();
  const header = useContentBlock('home-editorial', 'home.manifest.header');
  const body = useContentBlock('home-editorial', 'home.manifest.body');

  const eyebrow = header?.heading || t('homeEditorial.manifestoEyebrow');
  const heading = header?.subheading || t('homeEditorial.manifestoHeading');
  const bodyHtml = body?.body || `<p>${t('homeEditorial.manifestoBody')}</p>`;

  return (
    <ContentBlockPlaceholder blockKey="home.manifest.*">
      <section
        data-testid="editorial-intro"
        style={{
          maxWidth: '900px',
          margin: '120px auto',
          padding: '0 40px',
          textAlign: 'center',
        }}
      >
        <span className="eyebrow" style={{ marginBottom: '32px' }}>
          {eyebrow}
        </span>
        <h2
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: 'clamp(36px, 5vw, 64px)',
            fontWeight: 400,
            lineHeight: 1.05,
            letterSpacing: '-1px',
            color: 'var(--ink)',
            margin: '32px 0',
          }}
          dangerouslySetInnerHTML={{ __html: heading }}
        />
        <div
          style={{
            fontSize: '17px',
            lineHeight: 1.7,
            color: 'var(--ink-soft)',
            maxWidth: '640px',
            margin: '0 auto',
            fontFamily: 'var(--font-body)',
          }}
          dangerouslySetInnerHTML={{ __html: bodyHtml }}
        />
      </section>
    </ContentBlockPlaceholder>
  );
};

export default EditorialIntro;
